export enum RolloverQueryKeys {
  Primary = 'rollover/',
  VerifyByCoinId = 'rollover/verify-rollover-by-coin-id',
}
